import { z } from 'zod';

export const ChartPointSchema = z.object({
  label: z.string().default(''),
  value: z.number().default(0),
  // Opcionalmente, se precisar de timestamp no futuro
  // timeStamp: z.string().nullable().optional().default(null)
});

const CountersSchema = z.object({
  devices: z.number().default(0),
  activeDevices: z.number().default(0),
  faces: z.number().default(0),
  students: z.number().default(0),
  responsibles: z.number().default(0),
});

const EventsSchema = z.object({
  total: z.number().default(0),
  lpr: z.number().default(0),
  face: z.number().default(0),
  ivs: z.number().default(0),
  temp: z.number().default(0),
});

const ChartsSchema = z.object({
  currentWeek: z.array(ChartPointSchema).default([]),
  currentMonth: z.array(ChartPointSchema).default([]),
  currentYear: z.array(ChartPointSchema).default([]),
});

export const DashboardSchema = z.object({
  counters: CountersSchema.default({}),
  events: EventsSchema.default({}),
  charts: ChartsSchema.default({}),
});
